// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Search_wrap__2DbDt"};